<template>
  <div class="contacts-page">
    <div class="row" v-if="commonContacts.length && !isProduct">
        <template v-for="(item, index) in commonContacts">
          <div class="col-default-4 col-tablet-6 col-v-tablet-12" :key="`common-contact-${index}-${item.name}`">
            <contacts-card
                :show-image="false"
                :data="{
                        image: item.image.link,
                        name: item.name,
                        position: item.position.value,
                        email: adaptRequisites(item.emails),
                        phone: item.phones
                    }">
            </contacts-card>
          </div>
        </template>
    </div>
    <z-accordion multiple v-if="adaptedContacts.length">
      <template v-for="(item, index) in adaptedContacts">
        <z-accordion-item :id="item.xmlId" :key="`${item.xmlId}${index}`">
          <template v-slot:header>
            <span>{{ item.value }}</span>
          </template>
          <template v-slot:body>
            <div class="contacts-page__container">
              <z-list>
                <template v-for="(subItem, subIndex) in item.items">
                  <z-list-item v-if="subItem.id !== ''" :key="`subIndex-anchors-${subItem.id}-${subIndex}`">
                    <z-link :href="`#${subItem.id}`" v-html="subItem.name"></z-link>
                  </z-list-item>
                </template>
              </z-list>
            </div>
            <template v-for="(subItem, subIndex) in item.items">
              <div class="contacts-page__container" :key="`subIndex-${subItem.name}-${subIndex}`">
                <div v-if="subItem.name !== ''" class="black-5-bg u-all-padding--s u-bottom-margin--m">
                  <z-caption tag="h5" class="u-margin--no black-40-text" :id="subItem.id">
                    {{ subItem.name }}
                  </z-caption>
                </div>
                <div class="row">

                  <template v-for="(contact, contactIndex) in subItem.items">
                    <div class="col-default-4 col-tablet-6 col-v-tablet-12"
                         :key="`contact-${contactIndex}-${subIndex.name}`">
                      <contacts-card
                          :data="{
                        image: contact.image.link,
                        name: contact.name,
                        position: contact.position.value,
                        email: adaptRequisites(contact.emails),
                        phone: adaptRequisites(contact.phones)
                    }">
                      </contacts-card>
                    </div>
                  </template>

                </div>
              </div>
            </template>

          </template>
        </z-accordion-item>
      </template>
    </z-accordion>
  </div>
</template>

<script>
export default {
    name: 'contacts-page',
    props: {
        isProduct: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            contacts: this.isProduct ? this.$root?.app?.components['products-detail']?.contacts || [] : this.$root?.app?.components?.contacts?.accordions || [],
            commonContacts: this.isProduct ? [] : this.$root?.app?.components?.contacts['common-contacts'] || []
        }
    },
    computed: {
        adaptedContacts () {
            if (this.contacts.length) {
                return this.contacts.slice().map((item) => ({
                    ...item,
                    items: this.filterContacts(item)
                }))
            }
            return []
        }
    },
    methods: {
        filterContacts (data) {
            const currentTypesId = new Set()
            const currentTypes = new Map()
            data.items.forEach((item) => {
                currentTypesId.add(item.type['xml-id'])
                currentTypes.set(item.type['xml-id'], item.type)
            })
            const checkId = (id) => {
                return id === '' ? 1 : 0
            }

            return [...currentTypesId]
                .sort((itemA, itemB) => checkId(itemB) - checkId(itemA))
                .map((item) => {
                    const value = currentTypes.get(item)
                    return {
                        name: value.value,
                        id: value['xml-id'],
                        items: data.items.filter((dataItem) => dataItem.type['xml-id'] === item)
                    }
                })
        },
        adaptRequisites (data) {
            return data.slice().map((item) => item.value)
        }
    }
}
</script>

<style lang="scss">
.contacts-page {
   &__container {
     margin-top: $token-spacers-s;
   }
}
</style>
